import { Site } from '@shapeable/kelp-forest-alliance-types';
import { useSite as useSiteCore } from '@shapeable/ui'

export const useSite = () => useSiteCore<Site>();
